import { render, staticRenderFns } from "./CreateSensorButton.vue?vue&type=template&id=8f86e982&scoped=true&"
import script from "./CreateSensorButton.vue?vue&type=script&lang=js&"
export * from "./CreateSensorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f86e982",
  null
  
)

/* custom blocks */
import block0 from "./CreateSensorButton.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f86e982')) {
      api.createRecord('8f86e982', component.options)
    } else {
      api.reload('8f86e982', component.options)
    }
    module.hot.accept("./CreateSensorButton.vue?vue&type=template&id=8f86e982&scoped=true&", function () {
      api.rerender('8f86e982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SensorList/CreateSensorButton.vue"
export default component.exports